import React, { useEffect, useState } from "react";
import {
  BetaForm as useBetaForm,
  ButtonBase,
  TextInputBase,
} from "@reusejs/react";
import ResendCode from "../authentication/ResendCode";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { setBankerTokens, setBankerUser } from "store";
import { intiateLoginWithOtp, loginWithOtp, getUser, getTeams } from "services";

export default function BankerLoginForm(props: any) {
  const router = useRouter();
  const dispatch = useDispatch();
  const [emailVerified, setEmailVerified] = useState(false);
  const form = useBetaForm({
    email: "",
  });

  const loginForm = useBetaForm({
    email: "",
    otp: "",
  });

  const form_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
  };

  const loginForm_constraints = {
    email: {
      presence: {
        allowEmpty: false,
      },
      email: true,
    },
    otp: {
      presence: {
        allowEmpty: false,
        message: "^OTP can't be blank",
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
    loginForm.setValidationRules(loginForm_constraints);
  }, []);

  const handleEmailSubmission = async () => {
    try {
      if (form.validate()) {
        await intiateLoginWithOtp(form);
        loginForm.setField("email", form.value.email);
        setEmailVerified(true);
      }
    } catch (error: any) {
      console.log("check here error", error);
    }
  };

  const handleSubmit = async () => {
    try {
      if (loginForm.validate()) {
        const data: any = await loginWithOtp(loginForm);
        dispatch(setBankerTokens(data));
        const user = await getUser();
        dispatch(setBankerUser(user));
        // get teams
        // filter branch uuid
        // store branch uuids in redux
        // make api call and get the branch
        router.push("/");
      }
    } catch (error: any) {
      console.log("check here error", error);
    }
  };

  const handleResendCode = async () => {
    try {
      console.log("check here form ", form.value);
      await intiateLoginWithOtp(form);
    } catch (error) {
      console.log("check here error", error);
    }
  };

  return (
    <div className="mt-6 space-y-6">
      {!emailVerified ? (
        <>
          <div className="">
            <TextInputBase
              labelBaseProps={{
                label: "Email*",
              }}
              name={"email"}
              onChange={(val) => form.setField("email", val)}
              placeholder={"Enter your email"}
              type={"text"}
              error={
                form.errors.get("email") ? (
                  <p className="mt-2 text-sm text-red-500">
                    {form.errors.get("email")[0]}
                  </p>
                ) : null
              }
              value={form.getField("email")}
              htmlFor={"email"}
            />
          </div>

          <div className="flex flex-col space-y-4">
            <ButtonBase
              variant="primary"
              label="Sign in"
              onClick={handleEmailSubmission}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "w-full",
                padding: "px-4 py-3",
              }}
            />
          </div>
        </>
      ) : (
        <>
          <div>
            <TextInputBase
              labelBaseProps={{
                label: "Email*",
              }}
              name={"email"}
              onChange={(val) => loginForm.setField("email", val)}
              placeholder={"Enter your email"}
              type={"text"}
              error={
                loginForm.errors.get("email") ? (
                  <p className="mt-2 text-sm text-red-500">
                    {loginForm.errors.get("email")[0]}
                  </p>
                ) : null
              }
              value={loginForm.getField("email")}
              htmlFor={"email"}
              disabled={emailVerified}
            />
          </div>
          <div>
            <TextInputBase
              labelBaseProps={{
                label: "OTP*",
              }}
              name={"otp"}
              onChange={(val) => loginForm.setField("otp", val)}
              placeholder={"Enter your OTP"}
              type={"text"}
              error={
                loginForm.errors.get("otp") ? (
                  <p className="mt-2 text-sm text-red-500">
                    {loginForm.errors.get("otp")[0]}
                  </p>
                ) : null
              }
              value={loginForm.getField("otp")}
              htmlFor={"otp"}
            />
            <div className="mt-2 text-sm">
              <ResendCode resendCallback={handleResendCode} />
            </div>
          </div>
          <div className="flex flex-col space-y-4">
            <ButtonBase
              variant="primary"
              label="Sign in"
              onClick={handleSubmit}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "w-full",
                padding: "px-4 py-3",
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}
